module.exports = __webpack_public_path__ + "media/images/indicators/volumeChuva-710caf19fa4fc727dda39999f75d6710.png";